import { type Tracker, createTracker } from "@infinitaslearning/module-data-analyticstracker";
import type { ROLES } from "@infinitaslearning/module-he-common";
import { trackingENV as getAnalyticsEnv } from "constants/env-constants";

let analyticsTracker: Tracker;
let trackerInitialized = false;

export type RoleKeys = Exclude<keyof typeof ROLES, "TEST">;
type TaggingRoleTypes = "instructor" | "learner" | "administrator" | "editor";

const TAGGING_ROLE_TYPES: Record<RoleKeys, TaggingRoleTypes> = {
  TEACHER: "instructor",
  STUDENT: "learner",
  ADMIN: "administrator",
  EDITOR: "editor",
};

export const initAnalyticstracker = (): Tracker | null => {
  try {
    analyticsTracker = createTracker({
      platform: "Studiemeister",
      environment: getAnalyticsEnv(),
      opCo: "noordhoff",
      platformVariant: "hoo",
    });
    return analyticsTracker;
  } catch (_error) {
    return null;
  }
};
export const setAnalyticsUser = (userId: number, role: RoleKeys): void => {
  analyticsTracker?.identify({
    id: userId.toString(),
    type: TAGGING_ROLE_TYPES[role],
  });
};

export const setAnalyticsPage = (id: string, type: string, brandName = ""): void => {
  const analyticsPage = {
    category: "hoo-online-titles",
    ...(id ? { id } : {}),
    type,
    brand: { name: brandName },
  };
  analyticsTracker?.page(analyticsPage);
};

export const getAnalyticsTracker = (): Tracker | undefined => {
  if (!analyticsTracker && !trackerInitialized) {
    trackerInitialized = true;
  }
  return analyticsTracker;
};
